import store from '@/store';

export function initFbSdk() {
  return new Promise((resolve, reject) => {
    window.fbAsyncInit = function() {
      const defaults = {
        cookie: true,
        xfbml: true,
        appId: store.getters.extensionSettings.facebook.app_id,
        version: 'v5.0'
      }
      window.FB.init(defaults);
      resolve(window.FB)
    };
    /* eslint-disable */
    ;(function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) { return; }
      const js = d.createElement(s); js.id = id
      js.src = '//connect.facebook.net/en_US/sdk.js'
      js.onerror = error => { loadError(error); reject(error) } // non-facebook line
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
    /* eslint-enable */
  })
}

export function getFbLoginStatus() {
  return new Promise((resolve) => window.FB.getLoginStatus(resolve))
}

export function fbLogin(options) {
  return new Promise((resolve) => window.FB.login(resolve, options))
}

export function fbLogout() {
  return new Promise((resolve) => window.FB.logout(resolve))
}
